export default "__VITE_ASSET__ZrbU9v5D__"